import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e01d0702"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "departure" }
const _hoisted_3 = { class: "arrival" }


export default /*#__PURE__*/_defineComponent({
  __name: 'TimetableResultsHeader',
  props: {
    departureText: {},
    arrivalText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.departureText), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.arrivalText), 1)
  ]))
}
}

})